const ApiURL = {

    
    login: "user/login",
    register: "user/registration",
    getTransactionList: "user/transactions",
    getCurrencyList: "currency/list", 
    getLanguageList: "language/list",
    getProviderList: "provider/list",
    getGameCategoriesList: "game/category/list",
    getGameList: "game/list",
    getReleasedGame: "/game/new_released",
    getFavouriteGames: "/user/favourite/list",
    getGameURL:"/game/get-game-url",
    getFeatureGames: "game/random",
    isTokenAlive : "user/is_token_alive",
    getAccountList: "provider/account-list",
    importGames: "game/import-games"
}

export default ApiURL;
